<template>
	<v-col cols="5" class="flex-none mx-auto">
		<div class="inventory-form">
			<div class="form-input">
				<label>Vendor Name <span class="form-error">*</span></label>

				<div class="search-input">
					<v-text-field
						ref="searchText"
						prepend-inner-icon="mdi-magnify"
						outlined
						dense
						hide-details="auto"
						:value="itemData.vendorId ? renderVendor(itemData.vendorId) : ''"
						clearable
						@click:clear="
							itemData.vendorId = null;
							showSearch = false;
						"
						@keyup="searchVendors($event)"
						:disabled="!canManageInventory"
					></v-text-field>

					<div v-if="showSearch" class="search-input-dropdown">
						<div class="search-input-dropdown-results">
							<ul>
								<li v-if="searchResults.length == 0">No Results Found</li>
								<li
									v-for="(res, resIndex) in searchResults"
									:key="resIndex"
									@click="setVendor(res)"
								>
									<p>{{ res.companyName }}</p>
								</li>
							</ul>
						</div>
					</div>
				</div>

				<p v-if="validation.itemData.vendorId.$error" class="form-error">
					* Please specify a vendor
				</p>
			</div>

			<div class="form-input">
				<label>Vendor Part #</label>
				<v-text-field
					outlined
					dense
					hide-details="auto"
					v-model="itemData.vendorPartNumber"
					:disabled="!canManageInventory"
				></v-text-field>
			</div>

			<div class="form-input">
				<label>Vendor Cost</label>
				<currency-text-field v-model="itemData.vendorCost" :disabled="!canManageInventory" />
			</div>

			<div class="form-input">
				<label>Lead Time</label>
				<v-text-field
					class="number-input"
					outlined
					dense
					hide-details="auto"
					v-model="itemData.leadTime"
					type="number"
					min="0"
					:disabled="!canManageInventory"
				></v-text-field>
			</div>
		</div>
	</v-col>
</template>

<script>
import gql from "graphql-tag";
export default {
	name: "InventoryItemVendorsView",
	props: {
		validation: {
			type: Object,
		},
		canManageInventory: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			itemData: {
				vendorId: null,
				vendorName: "",
				vendorPartNumber: null,
				vendorCost: null,
				leadTime: null,
			},
			showSearch: false,
			searchResults: [],
			vendors: [],
		};
	},
	apollo: {
		vendors: {
			query() {
				return gql`
					query {
						vendors(skip: 0, take: 500, order: { companyName: ASC }) {
							items {
								vendorId
								companyName
								accountNumber
								addresses {
									addressLine1
									addressLine2
									city
									state
									postalCode
									isPrimaryAddress
								}
							}
							pageInfo {
								hasNextPage
								hasPreviousPage
							}
						}
					}
				`;
			},
			update: (data) => data.vendors.items,
		},
	},
	methods: {
		setVendor(vendor) {
			this.itemData.vendorId = vendor.vendorId;
			this.$refs.searchText.$refs.input.value = vendor.companyName;

			//reset the search display
			this.showSearch = false;
		},

		renderVendor(vendorId) {
			let vendorById = this.vendors.find((obj) => obj.vendorId == vendorId);

			return vendorById ? vendorById.companyName : "";
		},

		searchVendors(event) {
			//temporary filter search results by keywords
			function filterByValue(array, string) {
				return array.filter((o) =>
					Object.keys(o).some((k) => String(o[k]).toLowerCase().includes(string.toLowerCase()))
				);
			}

			//replace with res.data once api is setup
			this.searchResults = filterByValue(this.vendors, event.target.value);
			this.showSearch = true;
		},
	},
	computed: {
		storeItem() {
			return this.$store.getters.inventoryItem;
		},
	},
	watch: {
		// Re-adopt the store object whenever the parent view's async fetch
		// replaces it — children mount before the parent's mounted() completes,
		// so a one-shot read here can capture a stale tree and orphan edits.
		storeItem: {
			immediate: true,
			handler(item) {
				this.itemData = item;
			},
		},
	},
	beforeDestroy() {
		//push current item data to state
		this.$store.dispatch("updateInventoryItem", this.itemData);

		//let parent component know data has been updated in state
		this.$emit("updated");
	},
};
</script>

<style lang="scss" scoped>
.inventory {
	&-form {
		display: flex;
		flex-flow: column;
		align-items: center;

		.form-input:not(:first-child) {
			.v-text-field {
				min-width: 30rem;
			}
		}
	}
}

.search-input {
	position: relative;
	display: flex;
	min-width: 30rem;

	&-dropdown {
		position: absolute;
		left: 0;
		bottom: -28.5rem; //height of the filter + extra spacing
		background-color: $color-white;
		border-radius: 3px;
		width: 40vw;
		max-width: 40vw;
		height: 28rem;
		box-shadow: rgba(50, 50, 93, 0.15) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
		z-index: 1000;
		overflow-y: auto;
		overflow-x: hidden;

		&-results {
			ul {
				list-style: none;
				padding-left: 0;

				li {
					display: flex;
					flex-flow: row wrap;
					align-items: center;
					font-size: 1.3rem;
					white-space: nowrap;
					transition: all 0.4s;
					padding: 0.8rem;
					padding-left: 1rem;

					&:hover {
						cursor: pointer;
						background-color: $color-gray-light;
					}

					p {
						font-size: 1.4rem;
						font-weight: normal;
						text-transform: uppercase;
					}
				}
			}
		}
	}
}
</style>
